import React from 'react';

import { STATUS, SUCCESS_AUTO_CLOSE_TIME } from '../../constants';
import { ToastItemProps } from './ToastItem.types';
import Text from '../../../Text';
import {
  StatusCompleteFilled,
  StatusAlertFilled,
  StatusWarningFilled,
  InfoCircleFilled,
} from '@wix/wix-ui-icons-common';
import TextButton from '../../../TextButton';
import { st, classes } from './ToastItem.st.css';

export const ToastItem: React.FC<ToastItemProps> = ({
  children,
  toastId,
  onClose,
  showDismiss = true,
  status = STATUS.DEFAULT,
  action,
  dismissTitle = 'Dismiss',
  dataHook,
}) => {
  React.useEffect(() => {
    if (status !== STATUS.SUCCESS) return;
    const timer = setTimeout(() => onClose(), SUCCESS_AUTO_CLOSE_TIME);
    return () => clearTimeout(timer);
    // TODO: fix ESLint error
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const icon = React.useMemo(() => {
    switch (status) {
      case STATUS.SUCCESS: {
        return (
          <div className={classes.iconContainer}>
            <StatusCompleteFilled />
          </div>
        );
      }
      case STATUS.ERROR: {
        return (
          <div className={classes.iconContainer}>
            <StatusAlertFilled />
          </div>
        );
      }
      case STATUS.WARNING: {
        return (
          <div className={classes.iconContainer}>
            <StatusWarningFilled />
          </div>
        );
      }
      default: {
        return (
          <div className={classes.iconContainer}>
            <InfoCircleFilled />
          </div>
        );
      }
    }
  }, [status]);

  const handleDismissClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClose(e);
  };

  return (
    <div
      id={toastId as string}
      className={st(classes.toast, {
        showDismiss,
        success: status === STATUS.SUCCESS,
        error: status === STATUS.ERROR,
        warning: status === STATUS.WARNING,
      })}
      data-hook={dataHook ? `toast-item ${dataHook}` : `toast-item`}
      data-status={status}
      // will be redefined after proper component spec
      role="alert"
      aria-live="polite"
    >
      {icon}
      <Text
        light
        size="medium"
        dataHook="toast-text"
        className={classes.toastText}
      >
        {children}
      </Text>
      {action && (
        // @ts-ignore
        <TextButton
          skin="light"
          size="medium"
          underline="always"
          as={action.href ? 'a' : undefined}
          href={action.href}
          onClick={action.onClick}
          className={classes.secondAction}
          dataHook="action-button"
        >
          {action.title}
        </TextButton>
      )}
      {showDismiss && (
        // @ts-ignore
        <TextButton
          skin="light"
          size="medium"
          underline="always"
          onClick={handleDismissClick}
          dataHook="dismiss-button"
        >
          {dismissTitle}
        </TextButton>
      )}
    </div>
  );
};
